import React, { useState, useRef, useEffect } from 'react'
import notification from '../../../assets/tabler-icon-bell.svg';
import deleteIcon from '../../../assets/icon-trash.png';
import crossIcon from '../../../assets/cross_fff.svg';
import successIcon from '../../../assets/u_check.svg';

import './notification.css'

const NotificationCompo = () => {
    const [notificationOpen, setNotificationOpen] = useState(false);
    const notificationRef = useRef(null);

    // Sample notification data based on your image
    const [notifications, setNotifications] = useState([
        {
            id: 1,
            title: "Developer has registered Solution 1",
            date: "Oct 19, 2024, 2:20 PM",
            type: "registration",
            isRead: false
        },
        {
            id: 2,
            title: "You have successfully published a new solution.",
            date: "Oct 19, 2024, 2:20 PM",
            type: "success",
            isRead: false
        },
        {
            id: 3,
            title: "You have deleted Solution 4 successfully.",
            date: "Oct 19, 2024, 2:20 PM",
            type: "success",
            isRead: false
        }
    ]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setNotificationOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleNotificationClick = () => {
        setNotificationOpen(!notificationOpen);
    };

    const handleDeleteNotification = (id) => {
        setNotifications(notifications.filter(notif => notif.id !== id));
        console.log('Delete notification:', id);
    };

    const handleCheckboxChange = (id) => {
        setNotifications(notifications.map(notif =>
            notif.id === id ? { ...notif, isRead: !notif.isRead } : notif
        ));
    };


    return (
        <div className="notification-container" ref={notificationRef}>
            <img
                src={notification}
                alt="Notification"
                height={36}
                width={36}
                onClick={handleNotificationClick}
                className="notification-bell"
            />

            {notificationOpen && (
                <div className="notification-dropdown">
                    <div className="notification-header">
                        <h3>Notifications</h3>
                        <button
                            className="close-btn"
                            onClick={() => setNotificationOpen(false)}
                        >
                            {/* ×  */}
                            <img src={crossIcon} alt="Close" className="close-icon" />
                        </button>
                    </div>

                    <div className="notification-list">
                        {notifications.map((notif) => (
                            <div key={notif.id} className="notification-item">
                                <div className="notification-content">
                                    <div className={`notification-icon ${notif.type}`}>
                                        {/* ✓ */}
                                        <img src={successIcon} alt="Success" />
                                    </div>
                                    <div className="notification-text row">
                                        <p className="notification-title col-md-6">{notif.title}</p>
                                        <span className="notification-date col-md-6">{notif.date}</span>
                                    </div>
                                </div>
                                <button
                                    className="delete-notification"
                                    onClick={() => handleDeleteNotification(notif.id)}
                                >
                                    <img src={deleteIcon} alt="Delete" className="delete-icon" />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default NotificationCompo